import { AuthProvider } from "./contexts/AuthContext";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ApplicationRouter from "./ApplicationRouter";
import "./index.scss";
import "@fontsource-variable/figtree";
import i18n from "./i18n";

const fontFamily = `'Figtree Variable', sans-serif`;

const theme = extendTheme({
  fonts: {
    heading: fontFamily,
    body: fontFamily,
  },
  direction: (localStorage.getItem("lang") || i18n.language || "en") === "ar" ? "rtl" : "ltr",
  colors: {
    // Restored after @chakra-ui/theme removed social brand palettes in v3.
    whatsapp: {
      50: "#dffeec",
      100: "#b9f5d0",
      200: "#90edb3",
      300: "#65e495",
      400: "#3cdd78",
      500: "#22c35e",
      600: "#179848",
      700: "#0c6c33",
      800: "#01421c",
      900: "#001803", 
    },
  },
  // withDefaultProps({
  //   defaultProps: {
  //     colorScheme: 'whatsapp'
  //   },
  //   components: ['Button'],
  // })
});

const queryClient = new QueryClient();

function App() {
  return (
    <ChakraProvider
      theme={theme}
      toastOptions={{
        defaultOptions: {
          position: "top-right",
          isClosable: true,
          variant: "subtle",
          containerStyle: {
            // marginTop: "61px",
          },
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ApplicationRouter />
        </AuthProvider>
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default App;
